import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

import eventBus from './eventBus';
import { getValue } from './helpers';
import { ROUTES } from '../resources/routes-constants';
import { PROFILE_STATUS, USER_TYPE } from '../enums/applicationEnums';

const withAuth = (Component: any) => {
  const AuthenticatedComponent = (props: any) => {
    const navigate = useNavigate();
    const isAuthenticated = getValue('authToken');
    const profileStatus = getValue('profileStatus');
    const userRole = getValue('userType');

    const location = useLocation();
    const pathname = location.pathname;

    useEffect(() => {
      const handleLogout = () => navigate('/');
      eventBus.on('logout', handleLogout);
  
      return () => {
        eventBus.remove('logout', handleLogout);
      };
    }, [navigate]);

    const publicRoutes = [
      '/',
      '/sign-up'
    ];
    const isPublicRoute = publicRoutes.includes(pathname);

    const employerRoutes = [
      '/dashboard',
      '/edit-company-profile',
      '/chat',
      '/job-description',
      '/idealize-candidate',
      '/job-description-summary',
      '/candidate-selection',
      '/qualified-candidates'
    ];
    const isEmployerRoute = employerRoutes.includes(pathname);

    const adminRoutes = [
      '/adminDashboard',
      '/adminUsers',
      '/adminPlans'
    ];
    const isAdminRoute = adminRoutes.includes(pathname);

    if (!isAuthenticated && isEmployerRoute) {
      return <Navigate to="/" />;
    }

    if (!isAuthenticated && isAdminRoute) {
      return <Navigate to="/" />;
    }

    if (!isAuthenticated && (pathname === ROUTES.DASHBOARD_EMPTY_ROUTE || pathname === ROUTES.COMPANY_PROFILE_ROUTE)) {
      return <Navigate to="/" />;
    }

    if (isAuthenticated && isPublicRoute) {
      if(userRole === USER_TYPE.EMPLOYER) {
        return <Navigate to="/dashboard" />;
      } else {
        return <Navigate to="/adminDashboard" />;
      }
    }

    if ((isAuthenticated && isEmployerRoute) && (userRole === USER_TYPE.ADMIN)) {
      return <Navigate to="/adminDashboard" />;
    }

    if ((isAuthenticated && (pathname === ROUTES.DASHBOARD_EMPTY_ROUTE || pathname === ROUTES.COMPANY_PROFILE_ROUTE)) && (userRole === USER_TYPE.ADMIN)) {
      return <Navigate to="/adminDashboard" />;
    }

    if ((isAuthenticated && isAdminRoute) && (userRole === USER_TYPE.EMPLOYER)) {
      return <Navigate to="/dashboard" />;
    }

    if (isAuthenticated && (pathname === ROUTES.DASHBOARD_EMPTY_ROUTE) && (userRole === USER_TYPE.EMPLOYER)) {
        if (profileStatus === PROFILE_STATUS.PROFILE_IN_PROGRESS) {
          return <Navigate to="/company-profile" />;
        }
        if (profileStatus === PROFILE_STATUS.COMPLETED) {
          return <Navigate to="/dashboard" />;
        }
    }

    if (isAuthenticated && (pathname === ROUTES.COMPANY_PROFILE_ROUTE) && (userRole === USER_TYPE.EMPLOYER)) {
      if (profileStatus === PROFILE_STATUS.ADMIN_VERIFICATION_IN_PROGRESS) {
        return <Navigate to="/dashboard-unaccess" />;
      }
      if (profileStatus === PROFILE_STATUS.COMPLETED) {
        return <Navigate to="/dashboard" />;
      }
    }

    if ((isAuthenticated && isEmployerRoute) && (userRole === USER_TYPE.EMPLOYER)) {
      if (profileStatus === PROFILE_STATUS.PROFILE_IN_PROGRESS) {
        return <Navigate to="/company-profile" />;
      }
      if (profileStatus === PROFILE_STATUS.ADMIN_VERIFICATION_IN_PROGRESS) {
        return <Navigate to="/dashboard-unaccess" />;
      }
    }

    return <Component {...props} />;
  };

  return AuthenticatedComponent;
};

export default withAuth;
